import React, { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import "./Layout.css";

const NAV = [
  { to: "/sessions", label: "세션 Sessions" },
  { to: "/participants", label: "참가자 Participants" },
  { to: "/users", label: "유저 Users" },
  { to: "/td-host", label: "TD 서버 IP" },
];

export default function Layout({ title, children }) {
  const { logout } = useAuth();
  const nav = useNavigate();
  const [open, setOpen] = useState(false);

  const doLogout = () => {
    logout();
    nav("/login", { replace: true });
  };

  return (
    <div className="admin-shell">
      <header className="admin-topbar">
        <button className="hamburger" onClick={() => setOpen((v) => !v)} aria-label="메뉴">
          <div /><div /><div />
        </button>
        <div className="admin-title">{title}</div>
        <button className="btn btn-ghost" onClick={doLogout}>로그아웃</button>
      </header>

      <aside className={`admin-sidebar ${open ? "open" : ""}`}>
        <div className="sidebar-brand">
          게임이냥
          <span>MUSEUMX ADMIN</span>
        </div>

        <nav className="sidebar-nav" onClick={() => setOpen(false)}>
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              className={({ isActive }) => `nav-item ${isActive ? "active" : ""}`}
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="sidebar-foot">
          <span className="tag tag-soft">/admin</span>
          <span className="tag tag-soft">{process.env.REACT_APP_MODE || "—"}</span>
        </div>
      </aside>

      <main className="admin-main">
        <div className="panel">{children}</div>
      </main>
    </div>
  );
}
